import React from 'react';
import SpinnerWheel from '../spinner-wheel/spinner-wheel';

const SidDrawerDescription = ({ navItems }) => (
    <aside className="eds-structure__drawer eds-structure__left-drawer">
        <div className="eds-structure__drawer-content">
            <div>
                <document-fragment tabindex="-1">
                    <ul className="eds-nav-list">
                        {navItems.map(({ content, items }) => (
                            <li key={content} className="eds-nav-list__item">
                                <button
                                    className="eds-btn--button eds-btn--anchor eds-link eds-nav-list-item eds-nav-list-item--link eds-nav-list-item--alt-theme"
                                    type="button"
                                >
                                    <div className="eds-list-item eds-list-item--align-middle">
                                        <div className="eds-list-item__contents">
                                            <div className="eds-nav-list__item__contents">
                                                {content}
                                                <div className="eds-nav-list__item__symbol eds-fx--fade-in">
                                                    <i className="eds-vector-image eds-icon--small eds-vector-image--grey-400">
                                                        <svg viewBox="0 0 24 24">
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M17 13.8l-5-5-5 5 1.4 1.4 3.6-3.6 3.6 3.6z"
                                                            />
                                                        </svg>
                                                    </i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                                <div className="eds-nav-list__sub-list">
                                    <ul className="eds-nav-list">
                                        {items.map(({ content }) => (
                                            <li
                                                key={content}
                                                className="eds-nav-list__item"
                                            >
                                                <a
                                                    href="?option=testing"
                                                    className="eds-nav-list-item eds-nav-list-item--link eds-nav-list-item--selected eds-nav-list-item--alt-theme"
                                                >
                                                    <div className="eds-list-item eds-list-item--align-middle">
                                                        <div className="eds-list-item__contents">
                                                            <div className="eds-nav-list__item__contents">
                                                                {content}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </li>
                        ))}
                    </ul>
                </document-fragment>
            </div>
        </div>
    </aside>
);

const Body = ({ children, pageTitle }) => (
    <div className="eds-structure__main-mask">
        <div className="eds-structure__fixed-bottom-bar-layout-wrapper">
            <div className="eds-fixed-bottom-bar-layout">
                <div className="eds-fixed-bottom-bar-layout__content">
                    <div className="eds-structure__main-container">
                        <div className="eds-structure__title-container eds-g-group">
                            <div className="eds-structure__title">
                                <div className="eds-l-mar-vert-2 eds-l-mar-left-2 eds-structure__title__toggle">
                                    <span className="eds-icon-button eds-icon-button--neutral">
                                        <button
                                            className="eds-btn--button eds-btn--none eds-btn--icon-only"
                                            type="button"
                                        >
                                            <i
                                                className="eds-vector-image eds-icon--small eds-vector-image--block"
                                                title="Toggle Navigation"
                                            >
                                                <svg viewBox="0 0 24 24">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M4 17h16v2H4v-2zM4 11h16v2H4zM4 5h16v2H4z"
                                                    />
                                                </svg>
                                                <span className="eds-is-hidden-accessible">
                                                    Toggle Navigation
                                                </span>
                                            </i>
                                        </button>
                                    </span>
                                </div>
                                <div className="eds-g-cell eds-l-mar-vert-2 eds-l-mar-left-1 eds-structure__title__heading">
                                    <h2 className="eds-structure__title__heading__text">
                                        {pageTitle}
                                    </h2>
                                </div>
                            </div>
                        </div>

                        <main className="eds-structure__main">{children}</main>
                    </div>
                </div>
                <div className="eds-fixed-bottom-bar-layout__bar" />
            </div>
        </div>
    </div>
);
const Structure = ({ header, pageTitle, navItems, isLoading, children }) => (
    <div className="eds-structure eds-structure--min-height eds-structure--independent-scrolling">
        <div className="eds-structure__header">{header}</div>
        {isLoading ? (
            <SpinnerWheel />
        ) : (
            <div className="eds-structure__body">
                <SidDrawerDescription navItems={navItems} />
                <Body pageTitle={pageTitle}>{children}</Body>
            </div>
        )}
    </div>
);

export default Structure;
